import { render, staticRenderFns } from "./EditInPlace.vue?vue&type=template&id=1f2d8f38&"
import script from "./EditInPlace.vue?vue&type=script&lang=js&"
export * from "./EditInPlace.vue?vue&type=script&lang=js&"
import style0 from "./EditInPlace.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports